'use client';

import { Box, Button, Container, MetaPill } from '@doist/marketist';
import { BlogCards } from 'app/components/blog-cards/blog-cards';
import { useTranslation } from 'app/i18n/client';
import { addProtocol } from 'app/services/contentful/add-protocol-to-url';
import cn from 'clsx';
import { SectionHeader } from 'components/SectionHeader/SectionHeader';
import { useLocale } from 'next-intl';
import { isDefined } from 'services/is-defined';
import css from './featured-integrations.module.css';
import type { IntegrationsHomeData } from 'app/[locale]/integrations/types';
function FeaturedIntegrations({
  fields: {
    featuredIntegrations
  }
}: IntegrationsHomeData) {
  const {
    title,
    description,
    selections = []
  } = featuredIntegrations?.fields ?? {};
  const locale = useLocale();
  const {
    t
  } = useTranslation(locale, 'integrations');
  const cards = selections.map(i => {
    if (!i?.fields) return null;
    if (!i?.fields.commonContent) return null;
    const {
      title,
      slug,
      featuredIntegrationScreenshot
    } = i.fields;
    const {
      tagline,
      categories = []
    } = i.fields.commonContent.fields;
    const src = addProtocol(featuredIntegrationScreenshot?.fields?.file?.url);
    return {
      title,
      description: tagline,
      href: `/integrations/apps/${slug}`,
      src: `${src}?w=340&fm=png`,
      pills: categories.filter(Boolean).map(c => <MetaPill key={c?.fields.name} href={`/integrations/category/${c?.fields.slug}`}>
                        {c?.fields.name}
                    </MetaPill>),
      withBorder: true
    };
  }).filter(isDefined);
  return <Box tag="section" className={cn(css.container)} data-sentry-element="Box" data-sentry-component="FeaturedIntegrations" data-sentry-source-file="featured-integrations.tsx">
            <Container className={css.header} width="sm" data-sentry-element="Container" data-sentry-source-file="featured-integrations.tsx">
                <SectionHeader style={{
        '--section-mb': 'var(--space-24)'
      }} title={title} subtitle={description} data-sentry-element="SectionHeader" data-sentry-source-file="featured-integrations.tsx" />
            </Container>
            <BlogCards cards={cards} data-sentry-element="BlogCards" data-sentry-source-file="featured-integrations.tsx" />
            <Box data-sentry-element="Box" data-sentry-source-file="featured-integrations.tsx">
                <Button variant="tertiary" href="/integrations/collection/most-popular" data-sentry-element="Button" data-sentry-source-file="featured-integrations.tsx">
                    {t('mostPopular')}
                </Button>
            </Box>
        </Box>;
}
export { FeaturedIntegrations };